import { z } from 'zod'

import { transactionSchema } from '../transaction/transactionApiTypeSchemas'

export const contactAddressOptionsSchema = z.object({
  addresses: z.array(z.string()),
})

export const contactRecentTransactionsSchema = z.object({
  recent_transactions: z.array(transactionSchema),
})

export const addressTransactionCountsSchema = z.object({
  transaction_counts: z.record(z.string(), z.number()),
})

export const addressUnknownTransactionCountsSchema = z.object({
  transaction_counts: z.array(z.tuple([z.string(), z.number()])),
})

export const contactInfoSchema = z.object({
  id: z.string(),
  name: z.string(),
  addr: z.string(),
  email: z.string().nullable(),
  customer_id: z.string().nullable(),
  vendor_id: z.string().nullable(),
})

export const contactsSchema = z.object({
  contacts: z.array(contactInfoSchema),
})

export type ContactRecentTransactions = z.infer<typeof contactRecentTransactionsSchema>
